import React, { Suspense } from 'react';
import { Card } from 'tea-component';
import ChartErrorBoundary from './ChartErrorBoundary';
import './index.scss';
import ChartAdapter from '@/pages/aigc/pages/Agent/ChatPage/components/MainContent/ChartAdapter';

interface IChartPreviewProps {
  data: any[];
}

const ChartPreview: React.FC<IChartPreviewProps> = React.memo(({ data }) => {
  return (
    <Card className="dba-chart-preview-container">
      <Card.Header>
        <h3>图表预览</h3>
      </Card.Header>
      <Card.Body>
        {/* <ChartErrorBoundary>
          <Suspense
            fallback={
              <div className="dba-chart-loading">
                <div className="dba-loading-spinner"></div>
                <p>图表加载中...</p>
              </div>
            }
          >
            <div className="dba-chart-content">
              <ChartAdapter apiData={[data]} />
            </div>
          </Suspense>
        </ChartErrorBoundary> */}
        <ChartAdapter apiData={data} />
      </Card.Body>
    </Card>
  );
});

ChartPreview.displayName = 'ChartPreview';

export default ChartPreview;

